import React, { useState, useEffect } from "react";
import { View, Text, Image, ScrollView } from "react-native";
import DropDownPicker from "react-native-dropdown-picker";
import { TextInput } from "react-native-paper";
import { FormattedMessage } from 'react-intl';

import HeaderDefault from "../../components/HeaderDefault";
import Button from "../../components/Button";

import AsyncStorage from "@react-native-async-storage/async-storage";

import api from "../../services/api";

import styles from "./styles";

const PurchaseMkt = () => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);
  const [qtddisponiveis, setQtddisponiveis] = useState(0);
  const [valueToken, setValueToken] = useState(1);
  const [qtdPay, setQtdPay] = useState(0);
  const [nameToken, setNameToken] = useState("GPX Token");
  const [items, setItems] = useState([
    {
      label: "GPX",
      value: "gpx",
      icon: () => (
        <Image
          source={require("../../../assets/imgs/gpx.png")}
          style={styles.iconSelect}
        />
      ),
    },
  ]);

  useEffect(() => {
    getDataCoin();
  }, []);

  const getDataCoin = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    const idCoin = await AsyncStorage.getItem("id_coin");

    api
      .get(`/actives/${idCoin}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log(res.data);

        setItems([
          {
            label: res.data.actives[0].name_token,
            value: res.data.actives[0].id,
            icon: () => (
              <Image
                source={{
                  uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${res.data.actives[0].path}`,
                }}
                style={styles.iconSelect}
              />
            ),
          },
        ]);
        setQtddisponiveis(res.data.actives[0].amount_token);
        setNameToken(res.data.actives[0].name_token);

        res.data.actives[0].type_value == "Valor Fixo"
          ? setValueToken(res.data.actives[0].single_value)
          : setValueToken(res.data.actives[0].total_value_token);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      
      <HeaderDefault title={<FormattedMessage id="purchaseMkt.headerComprar"/>} />

      <ScrollView style={styles.content}>
        <Text style={styles.title}><FormattedMessage id="purchaseMkt.txtDesejoComprar"/></Text>

        <View style={styles.contentSelect}>
          <DropDownPicker
            open={open}
            value={value}
            items={items}
            containerStyle={styles.dropdown}
            placeholder="Selecione"
            setOpen={setOpen}
            setValue={setValue}
            setItems={setItems}
          />
        </View>
        <Text style={styles.textAmount}>
        <FormattedMessage id="purchaseMkt.txtQuantidadeDisponivel"/>{" "}
          <Text style={{ fontWeight: "400" }}>
            {qtddisponiveis} {nameToken}
          </Text>
        </Text>

        <FormattedMessage id="purchaseMkt.txtQuantidadeTokens">
          {placeholder =>
        <TextInput
          style={{ backgroundColor: "#F2F2F2", marginTop: 50 }}
          keyboardType="numeric"
          placeholder={placeholder}
          value={qtdPay}
          onChangeText={(value) => setQtdPay(value)}
        />}
        </FormattedMessage>

        <Text style={styles.price}>
        <FormattedMessage id="purchaseMkt.txtNumQuantiToken"/> {nameToken} = {valueToken} <FormattedMessage id="purchaseMkt.txtCotacaoGpx"/>
        </Text>
      </ScrollView>

      <Button route={"ConfirmPurchase"} text={<FormattedMessage id="purchaseMkt.btnContinuar"/>} props={qtdPay} />
    </>
  );
};

export default PurchaseMkt;
